import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import aboutUsService from "./aboutUsService";
import { setServerError } from "../error500/error500Slice";

const initialState = {
  stories: [],
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

export const getInfo = createAsyncThunk(
  "about/getInfo",
  async (_, thunkApi) => {
    try {
      return await aboutUsService.getInfo();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      if (error.response && (error.response.status === 500 || error.response.status === 503)) {
        thunkApi.dispatch(setServerError(true));
      } 

      return thunkApi.rejectWithValue(message);
    }
  }
);

export const marketSlice = createSlice({
  name: "about",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.stories = action.payload;
      })
  },
});

export const { reset } = marketSlice.actions;
export default marketSlice.reducer;